import {collection, component, EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";
import {PricingScheduleSummaryData} from "../pricing-schedule/pricing-schedule.data";
import {MarkupData} from "../markup/markup.data";
import {PeriodScheduleReferenceData} from "../../system/period-schedule/period-schedule.data";

export class PriceLevelPosRestrictionsData extends EntityData<PriceLevelPosRestrictionsData> {
    @field manualOverride: boolean = true;
    @field membershipType: boolean = true;
    @field member: boolean = true;
    @field schedule: boolean = true;
    @field account: boolean = true;
    @field webTerminal: boolean = true;
}

export class PriceLevelScheduleSummaryData extends PricingScheduleSummaryData<PriceLevelScheduleSummaryData> {
    @identifier priceLevelScheduleId: number;
    @field name: string;
    @field discontinued: boolean;
}

export class PriceLevelData extends LocalisableEntityData<PriceLevelData> {
    @identifier priceLevelId: number;
    @field name: string;
    @field basePriceLevelId: number;
    @component modifier: MarkupData;
    @field priority: number;
    @component posRestrictions: PriceLevelPosRestrictionsData;
    @collection(PeriodScheduleReferenceData) periodSchedules: PeriodScheduleReferenceData[];
    @collection(PriceLevelScheduleSummaryData) schedules: PriceLevelScheduleSummaryData[];
}

export class PriceLevelReferenceData extends LocalisableEntityData<PriceLevelReferenceData> {
    @identifier priceLevelId: number;
    @field name: string;
}
